import React, { createContext, useContext, useMemo, useState } from 'react';

// What the Applications page tells the chat beside it (decision A, founder,
// 2026-09-28): the questions only the person can answer, each kept once at
// the top of Applications, and how that page answers them. A reply that
// started an application shows the ones holding it up with the page's own
// card and the page's own save, so an answer given in either place is the
// same answer, and both places see it land.
//
// The page (JobAgent, kept running by ApplicationsKeeper) publishes
// { items, companies, busy, save, refresh, Flow }, or null when it goes.
// Outside the shell nothing is provided: the page publishes to no one and
// the chat asks nothing.

const Bridge = createContext(null);

export function ApplicationsBridge({ children }) {
  const [asks, setAsks] = useState(null);
  const value = useMemo(() => ({ asks, setAsks }), [asks]);
  return <Bridge.Provider value={value}>{children}</Bridge.Provider>;
}

/** The page's side: how to publish, or null outside the shell. */
export const usePublishAsks = () => useContext(Bridge)?.setAsks || null;

/** The chat's side: what the page asks at the top, or null (not running). */
export const useOnceAsks = () => useContext(Bridge)?.asks || null;
